import React from 'react';
import { Link } from 'react-router-dom';

const ManageData: React.FC = () => {
  return (
    <div className="p-10">
      <h1>Manage Products & Items</h1>
      <Link
        className="flex flex-col items-start w-3/5 text-xl py-4 px-8 bg-slate-50 text-black border border-black mt-4"
        to="/items"
      >
        <span className="font-bold py-2">Items</span>
        <span className="text-sm py-2">View and add items</span>
      </Link>
      <Link
        className="flex flex-col items-start justify-center w-3/5 text-xl py-4 px-8 bg-slate-50 text-black border border-black mt-4"
        to="/manage-data/product-items-us"
      >
        <span className="font-bold py-2">🇺🇸 US Product-Items</span>
        <span className="text-sm py-2">View, add, and update product-item mappings for the US</span>
      </Link>
      <Link
        className="flex flex-col items-start justify-center w-3/5 text-xl py-4 px-8 bg-slate-50 text-black border border-black mt-4"
        to="/manage-data/product-items-ca"
      >
        <span className="font-bold py-2">🇨🇦 CA Product-Items</span>
        <span className="text-sm py-2">View, add, and update product-item mappings for Canada</span>
      </Link>
    </div>
  );
};

export default ManageData;
